import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import TableControlPanel from './TableControlPanel';

const TableOptionsSidebar = ({ editor, onClose, selectedTable }) => {
  if (!editor || !selectedTable) return null;

  return (
    <div className="h-full flex flex-col bg-gradient-to-br from-sky-50 to-blue-50 dark:from-slate-900 dark:to-slate-800">
      {/* Header */}
      <div className="p-4 border-b border-white/20 flex-shrink-0">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-slate-800 dark:text-slate-100">Opciones de Tabla</h3>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="hover:bg-white/50 dark:hover:bg-slate-700/50"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>

      {/* Table Control Panel Content */}
      <div className="flex-1 overflow-y-auto p-4">
        <TableControlPanel
          editor={editor}
          onClose={onClose}
          position={null}
          portalContainer={null}
          inSidebar={true}
        />
      </div>
    </div>
  );
};

export default TableOptionsSidebar;

